import { Injectable } from '@angular/core';
import { ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class PricingService {

    constructor(private api: ApiService) { }

    getPricingHistory(criteria): Observable<any> {
        return this.api.get('vna/pricing-history',criteria);
    }

    postPricingHistory(pricing: Object): Observable<any> {
        return this.api.post('vna/pricing-history', pricing);
    }
    removePricingHistory(pk: number): Observable<any> {
        return this.api.remove('vna/pricing-history', pk);
    }
    putPricingHistory(pricing: any): Observable<any> {
        return this.api.put('vna/pricing-history',pricing.pk,pricing);
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/pricing/services/pricing.service.ts